module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-auth"
  }, [_c('div', {
    staticClass: "popup-auth__content"
  }, [(!_vm.Helpers.isMobile()) ? _c('h3', {
    staticClass: "popup-auth__title popup__title"
  }, [_vm._v("\n            Авторизуйтесь через одну"), _c('br'), _vm._v("\n            из социальных сетей, чтобы войти:\n        ")]) : _c('h3', {
    staticClass: "popup-auth__title popup__title"
  }, [_vm._v("\n            Авторизуйтесь через"), _c('br'), _vm._v(" одну\n            из социальных сетей,"), _c('br'), _vm._v(" чтобы войти:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "popup-auth__socials"
  }, [_c('socials-auth')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ae7c2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Auth.vue
// module id = 496
// module chunks = 1